/**
 * useApi — module-local ApiClient + AbortController wiring.  Same contract as
 * RAO/hooks/useApi.ts.  Track A can promote to shared once stabilised.
 */
import { useCallback, useEffect, useRef } from 'react';
import type { ApiClient } from '@retail-ops/api-client';
import { useApiClient } from '@/contexts/ApiClientContext';

export interface UseApiHelpers {
  client: ApiClient;
  makeSignal: () => AbortSignal;
}

export function useApi(): UseApiHelpers {
  const client = useApiClient();
  const controllers = useRef<Set<AbortController>>(new Set());

  useEffect(() => {
    const set = controllers.current;
    return () => {
      set.forEach((c) => { try { c.abort(); } catch { /* ignore */ } });
      set.clear();
    };
  }, []);

  const makeSignal = useCallback((): AbortSignal => {
    const c = new AbortController();
    controllers.current.add(c);
    return c.signal;
  }, []);

  return { client, makeSignal };
}
